var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29310",
    "data-name": "Group 29310",
    transform: "translate(-1248 11380.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(1248 -11380.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29279",
    "data-name": "Group 29279",
    transform: "translate(510 -11684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49768",
    "data-name": "Path 49768",
    d: "M70.8.375A6.632,6.632,0,0,0,68.876,0a.279.279,0,0,0-.29.291,6.654,6.654,0,0,0,6.646,6.356Z",
    transform: "translate(688.712 312)",
    fill: "#bee070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49769",
    "data-name": "Path 49769",
    d: "M133.044,16.431a6.656,6.656,0,0,0-4.428-6.272C128.748,13.655,130.679,16.43,133.044,16.431Z",
    transform: "translate(630.901 302.216)",
    fill: "#7ed65f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49770",
    "data-name": "Path 49770",
    d: "M254,.087l-5.542,6.561A6.654,6.654,0,0,0,255.1.292a.278.278,0,0,0-.29-.291A6.686,6.686,0,0,0,254,.087Z",
    transform: "translate(515.492 312)",
    fill: "#348863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49771",
    "data-name": "Path 49771",
    d: "M253.975,2.338a6.623,6.623,0,0,0-1.115.289L248.432,8.9C251.469,8.9,253.934,5.969,253.975,2.338Z",
    transform: "translate(515.514 309.748)",
    fill: "#39aa59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49772",
    "data-name": "Path 49772",
    d: "M252.843,10.158a6.656,6.656,0,0,0-4.428,6.272c2.365,0,4.3-2.775,4.428-6.272Z",
    transform: "translate(515.53 302.217)",
    fill: "#3dcc4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49773",
    "data-name": "Path 49773",
    d: "M13,209.831h-6.3a.277.277,0,0,0-.231.431L9.5,214.821h6.968l-3.244-4.867a.277.277,0,0,0-.231-.123Z",
    transform: "translate(748.583 109.925)",
    fill: "#ffb13f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49774",
    "data-name": "Path 49774",
    d: "M227.6,209.831l-9.185,4.99h6.968l3.039-4.559a.277.277,0,0,0-.231-.431Z",
    transform: "translate(544.421 109.925)",
    fill: "#ff6237"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49775",
    "data-name": "Path 49775",
    d: "M221.66,209.954l-3.244,4.867h5.859l3.327-4.99h-5.71a.277.277,0,0,0-.231.123Z",
    transform: "translate(544.42 109.925)",
    fill: "#ff893b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49776",
    "data-name": "Path 49776",
    d: "M310.611,299.831l-3.7,4.038,3.7,3.244h.832a.277.277,0,0,0,.277-.277v-7Z",
    transform: "translate(459.192 23.251)",
    fill: "#ff893b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49777",
    "data-name": "Path 49777",
    d: "M142.481,299.831l-4.066,4.038,4.066,3.244h5.859v-7.282Z",
    transform: "translate(621.464 23.251)",
    fill: "#ffb13f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49778",
    "data-name": "Path 49778",
    d: "M59.915,299.831v7a.277.277,0,0,0,.277.277h6.69v-7.282Z",
    transform: "translate(697.063 23.251)",
    fill: "#ffcf70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageHighlighted);
export default __webpack_public_path__ + "static/media/packageHighlighted.1c7f00dc638e99da331b282cf1501f67.svg";
export { ForwardRef as ReactComponent };